// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"6c754a32","213":"5e2e72f1","236":"f8655dc7","323":"235a751b","619":"a3aa0b45","694":"3e70f2a4","788":"49156745","882":"5c8ecc51","886":"7333395c"}[chunkId] + ".chunk.js";
};